import { ITsNganhXetTuyen } from "../../../model/respone/category/ITsNganhXetTuyen";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTsNganhXetTuyenActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as ITsNganhXetTuyen[],
  LOAD_ERRR: "",
};
export const eTsNganhXetTuyenActionIds = generateActionTypeIds(
  eTsNganhXetTuyenActionsObj,
  "NGANH_XET_TUYEN"
);
export type ITsNganhXetTuyenActionTypes = IGenericActionType<
  typeof eTsNganhXetTuyenActionsObj,
  "NGANH_XET_TUYEN"
>;
